import { SnackbarData, SnackbarType } from "../components/Snackbar";
import { generateUniqueNumber } from "./utility";

type AddSnackbar = (snackbar: SnackbarData) => void;

export function showSuccessSnackbar(
  addSnackbar: AddSnackbar,
  message: string,
): void {
  addSnackbar(
    new SnackbarData(generateUniqueNumber(), message, SnackbarType.Success),
  );
}

export function showErrorSnackbar(
  addSnackbar: AddSnackbar,
  message: string,
): void {
  addSnackbar(
    new SnackbarData(generateUniqueNumber(), message, SnackbarType.Error),
  );
}

export function createSnackbarHelpers(addSnackbar: AddSnackbar) {
  return {
    showSuccess: (message: string) =>
      showSuccessSnackbar(addSnackbar, message),
    showError: (message: string) => showErrorSnackbar(addSnackbar, message),
  };
}
